module.exports = __webpack_public_path__ + "static/to-do-c50cfb7f61a3e0c34977bf15e0b33ed1.png";